import React, { FunctionComponent } from 'react';
import {
  Campaign
} from '@liveramp/motif/icons';
import {
  Body,
  Footer,
  Header,
  Row,
  Cell,
  Table
} from '@liveramp/motif/core/Table';
import Checkbox from '@liveramp/motif/core/Checkbox';
import Loader from '@liveramp/motif/core/Loader';
import WorkOrder from 'shared/interfaces/WorkOrder.interface';
import formatDate from 'shared/utils/formatDate';
import styles from './styles.module.scss';
import Impressions from './Impressions';
import StatusIcon from './StatusIcon';
import useBillingTableLogic from './useBillingTableLogic';
import EditBar from './EditBar';
import EditWorkOrderModal from './EditWorkOrderModal';
import CustomCell from './TableCell';

const BillingTable: FunctionComponent = () => {
  const {
    selectedWorkOrders,
    activeRowHandler,
    activeAllRows,
    workOrders,
    isTableLoaderVisible
  } = useBillingTableLogic();

  return (
    <>
      { selectedWorkOrders.length ? <EditWorkOrderModal /> : null}
      <Table className={styles.table}>
        <Header className={styles.tableHeader}>
          <Row className={styles.rowHeader}>
            <Cell className={styles.checkbox} padding="checkbox">
              <Checkbox
                checked={
                  selectedWorkOrders.length === workOrders.length
                  && selectedWorkOrders.length
                }
                onChange={
                  (event: React.ChangeEvent<HTMLInputElement>) => activeAllRows(workOrders, event.target.checked)
                }
                data-test-id="work-order-checkbox-for-all"
              />
            </Cell>
            <Cell>campaign</Cell>
            <Cell className={styles.endDateCol}>campaign end date</Cell>
            <Cell align="center">campaign status</Cell>
            <Cell>actual impressions</Cell>
            <Cell>work order id</Cell>
            <Cell>liveramp internal id</Cell>
            <Cell>wo created on</Cell>
          </Row>
        </Header>
        {
          isTableLoaderVisible
            ? (
              <div className={styles.loaderContainer}>
                <Loader />
              </div>
            )
            : (
              <Body className={styles.tableBody}>
                {workOrders.map((row: WorkOrder) => (
                  <Row
                    key={row.id}
                    className={`${styles.rowBody} ${selectedWorkOrders.includes(row) ? styles.activeRow : null}`}
                    data-test-id="work-order-row"
                    data-archived={row.isArchived}
                    hover={false}
                  >
                    <Cell className={styles.checkbox} padding="checkbox">
                      <Checkbox
                        data-test-id="work-order-checkbox"
                        checked={selectedWorkOrders.includes(row)}
                        onChange={
                          (event: React.ChangeEvent<HTMLInputElement>) => activeRowHandler(row, event.target.checked)
                        }
                      />
                      <Campaign className={styles.campaignIcon} />
                    </Cell>
                    <CustomCell>
                      {row.campaignName}
                    </CustomCell>
                    <Cell className={styles.endDateCol}>{row.endDate && formatDate(row.endDate)}</Cell>
                    <Cell align="center"><StatusIcon status={row.status} /></Cell>
                    <Cell>
                      <Impressions
                        impressions={row.impressions}
                        isImpressionDataNeeded={row.isImpressionDataNeeded}
                        workOrder={row}
                      />
                    </Cell>
                    <Cell>{row.tvWorkOrderNumber}</Cell>
                    <CustomCell>{row.opportunityId}</CustomCell>
                    <Cell>{row.createdOn && formatDate(row.createdOn)}</Cell>
                  </Row>
                ))}
              </Body>
            )
        }
        <Footer className={styles.tableFooter}>
          <Row>
            <Cell data-test-id="edit-bar">
              {selectedWorkOrders.length > 0 ? (
                <EditBar />
              ) : (
                <div className={styles.tableDefaultFooter} />
              )}
            </Cell>
          </Row>
        </Footer>
      </Table>
    </>
  );
};

export default BillingTable;
